import { ValueObject, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class EventMappingSearchCriteria extends ValueObject {
    public searchCriteria: string = "";
}